import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { FAMILIAR } from "../../mock";

const Familiar = () => {
  const scrollToForm = () => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="py-28 border-t border-[#131c31]" data-testid="familiar-section">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14">
        <div>
          <p className="font-mono text-[10px] tracking-[0.35em] text-[#6f7d9f] uppercase mb-6 reveal">{FAMILIAR.label}</p>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl leading-[0.98] tracking-tight mb-8 reveal" data-testid="familiar-headline">
            {FAMILIAR.headline}
          </h2>
          {FAMILIAR.paragraphs.map((p, i) => (
            <p key={i} className="text-[#aeb9d4] leading-relaxed mb-5 text-sm sm:text-base reveal">{p}</p>
          ))}
        </div>
        <div className="lg:pt-24">
          <p className="font-mono text-[10px] tracking-[0.3em] text-[#6b9be8] uppercase mb-8 reveal">{FAMILIAR.changesTitle}</p>
          <div className="space-y-6 reveal">
            {FAMILIAR.changes.map((c) => (
              <div key={c} className="flex items-start gap-4 border-b border-[#1c2740] pb-6">
                <ArrowRight size={18} className="text-[#6b9be8] mt-0.5 shrink-0" />
                <p className="text-[#dfe6f2] text-sm sm:text-base">{c}</p>
              </div>
            ))}
          </div>
          <button
            onClick={scrollToForm}
            data-testid="familiar-cta"
            className="cta-glow mt-10 flex items-center gap-2 bg-[#3f639f] hover:bg-[#4f76b8] text-white font-mono text-xs tracking-[0.25em] uppercase px-8 py-4 reveal"
          >
            <Check size={15} /> Reserve My Free Seat
          </button>
        </div>
      </div>
    </section>
  );
};

export default Familiar;
